import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type Plan = {
  name: string;
  ideal: string;
  was?: string;
  now: string;
  features: string[];
  cta: string;
  featured: boolean;
};
const plans: Plan[] = [{
  name: '📘 MegaPack Universitario Elite',
  ideal: 'Estudiantes que quieren aprobar sin recursar más',
  was: '$54.990 ARS',
  now: '$19.990 ARS',
  features: ['12 Tomos completos', 'Técnicas de retención y memoria', 'Protocolo Anti-Bloqueo en exámenes', 'Organización de cuatrimestre ARG', '5 Bonos estratégicos gratis', 'Garantía 7 días'],
  cta: 'Quiero mi MegaPack',
  featured: false
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="bg-radial-glow" data-id="element-124" data-mp="3cae762agd3qk">
      <div className="mx-auto max-w-5xl px-5 py-20 pb-[23px] pt-[18px]" data-id="element-125" data-mp="3vynisgb71zbg">
        <div className="grid items-stretch gap-6 md:grid-cols-2" data-id="element-126" data-mp="4scor44lpytm">
          {plans.map((plan, i) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={plan.featured ? 'relative flex w-full flex-col items-center rounded-3xl border border-gold/60 bg-ink-2 px-7 pb-7 pt-10 text-center shadow-[0_20px_60px_-20px_rgba(229,185,75,0.45)]' : 'relative flex w-full flex-col items-center rounded-3xl border border-verde/35 bg-ink-2 px-7 pb-7 pt-10 text-center'} data-id="element-127" data-mp="9rpb7nrk93vo" data-mpi={i}>
              {plan.featured && <span className="absolute -top-3 left-1/2 inline-flex -translate-x-1/2 items-center gap-1 rounded-full bg-gold px-4 py-1 text-[11px] font-black uppercase tracking-wide text-ink" data-id="element-128" data-mp="2uhy436esmtx4">
                  <StarIcon className="h-3 w-3 fill-current" data-id="element-129" data-mp="2rfa4xnbgobfc" /> Más completo
                </span>}

              <h3 className="font-display text-lg font-black text-white" data-id="element-130" data-mp="2mh8n15prui5g">{plan.name}</h3>
              <p className="mt-2 text-sm text-white/60" data-id="element-131" data-mp="315cx5lardlcm">
                <span className="font-semibold text-white/80" data-id="element-132" data-mp="2w7uwsjat4eg8">Ideal para:</span> {plan.ideal}
              </p>

              <div className="mt-6" data-id="element-133" data-mp="28hh18it0jxgw">
                {plan.was && <span className="text-base font-medium text-white/40 line-through" data-id="element-134" data-mp="28i8xzwyck18r">{plan.was}</span>}
                <div className="font-display text-4xl font-black text-gold-shine" data-id="element-135" data-mp="23kqmbysy37x2">{plan.now}</div>
                <p className="mt-1 text-xs font-semibold text-verde-soft" data-id="element-136" data-mp="2ihhqeldkd7t0">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-137" data-mp="3tuaffoeyzi5d">
                {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-white/80" data-id="element-138" data-mp="3ox1xnoxqhg4n">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} data-id="element-139" data-mp="a453vntx2r1" />
                    {f}
                  </li>)}
              </ul>

              <div className="mt-7 w-full" data-id="element-140" data-mp="573zh9bbgh2b">
                <CTAButton size="md" href="https://megapack-universitario-elite.impultienda.ar/checkout" variant={plan.featured ? 'gold' : 'verde'} className="w-full" data-id="element-141" data-mp="3nfv54d55afqy">
                  {plan.cta}
                </CTAButton>
              </div>

              <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-142" data-mp="j2y9xwrqnehj">
                {trust.map(({
              icon: Icon,
              label
            }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="a6qnmdsonhpw">
                    <Icon className="h-4 w-4 text-verde-soft" data-id="element-144" data-mp="e8bzpwxe7rz1" />
                    {label}
                  </span>)}
              </div>
            </motion.div>)}
        </div>

        <div className="mx-auto mt-8 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-verde/30 bg-verde/10 p-5 text-left" data-id="element-145" data-mp="16r95ckeo0lyf">
          <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" data-id="element-146" data-mp="3f55u169ledzd" />
          <p className="text-sm leading-relaxed text-white/75" data-id="element-147" data-mp="3a6umj26rsfkb">
            <span className="font-bold text-white" data-id="element-148" data-mp="358kp0kxkp2vj">Garantía de devolución de 7 días.</span> Si abrís
            los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el reembolso y
            te devolvemos el 100%. Sin formularios, sin drama, sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}